import { createAction } from '../../../actions/actionCreator';
import { ManagerUser, ActionsType } from '@card/types';
import { ShopFormatedType } from '../reducers/managerUsersReducers';

export enum ManagerUsersActionType {
  Get = 'managerUsers/get',
  GetSuccess = 'managerUsers/get_success',
  FilterUsers = 'managerUsers/filter_users',
  SetCurrentUserToEdit = 'managerUsers/set_current_user_to_edit',
  SaveShop = 'managerUsers/save_shop',
  ChangeUserType = 'managerUsers/change_user_type',
  FilterShops = 'managerUsers/filter_shops',
  SelectAll = 'managerUsers/select_all',
  SaveManagerUser = 'managerUsers/save_manager_user',
  SaveManagerUserSuccess = 'managerUsers/save_manager_user_success'
}

export const ManagerUsersActions = {
  getManagerUsers: () => createAction(ManagerUsersActionType.Get),
  // Next line is an Api Return.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getManagerUsersSuccess: (data: any) => createAction(ManagerUsersActionType.GetSuccess, data),
  filterUsers: (searchWord: string) => createAction(ManagerUsersActionType.FilterUsers, searchWord),
  filterShops: (searchWord: string) => createAction(ManagerUsersActionType.FilterShops, searchWord),
  setCurrentUserToEdit: (currentUserToEdit: ManagerUser) =>
    createAction(ManagerUsersActionType.SetCurrentUserToEdit, currentUserToEdit),
  saveShop: (shopToSave: ShopFormatedType) =>
    createAction(ManagerUsersActionType.SaveShop, shopToSave),
  changeUserType: () => createAction(ManagerUsersActionType.ChangeUserType),
  selectAll: () => createAction(ManagerUsersActionType.SelectAll),
  saveUser: (currentUserToEdit: ManagerUser, shopsToSave: ShopFormatedType[]) =>
    createAction(ManagerUsersActionType.SaveManagerUser, { currentUserToEdit, shopsToSave }),
  saveManagerUserSuccess: () => createAction(ManagerUsersActionType.SaveManagerUserSuccess)
};

export type ManagerUsersAction = ActionsType<typeof ManagerUsersActions>;
